import React, { useState, useEffect } from 'react'
import ClipLoader from "react-spinners/ClipLoader";

import moment from 'moment';

import Snackbar from '@material-ui/core/Snackbar';
import { theme } from '../../../..';
import { issueRefundToCourseCancellationRequest, putCourseCancellationRequestStatus } from '../../../../api/Courses';
import { COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS } from './CourseCancellationRequest';
const CourseCancellationRequestRow = props => {
    const { row, index, deleteRowInterface, setEditDetails } = props
    const id = row.id
    const [status, setStatus] = useState(row.status)
    const [delLoading, setDelLoading] = useState(false);
    const [SnackBarMessage, setSnackBarMessage] = useState()
    const [isSnackBarShow, setIsSnackBarShow] = useState(false)
    const [updateStatus, setUpdateStatus] = useState(false)
    const [issuingRefund, setIssuingRefund] = useState(false)
    const updateCourseCancellationRequestStatus = (status) => {
        if (window.confirm("Are you sure you want to update Status?")) {
            setUpdateStatus(true)
            putCourseCancellationRequestStatus(id,status,"", (response) => updateStatusCallback(response, status))
        }
    }
    const updateStatusCallback = (response, status) => {
        setUpdateStatus(false)
        if (response.status == 200) {
            setStatus(status)
            setSnackBarMessage("Status Updated Successfully")
            setIsSnackBarShow(true)
        } else {
            console.log("unable to update status");
            setSnackBarMessage("Something went wrong")
            setIsSnackBarShow(true)
        }
    }
    const issueRefund = () => {
        if (window.confirm("Are you sure you want to refund?")) {
            setIssuingRefund(true)
            issueRefundToCourseCancellationRequest(id, (response) => {
                setIssuingRefund(false)
                if (response.status == 200) {
                    setStatus(COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.DONE_BY_DUBUDDY)
                    setSnackBarMessage("Refund Issued Successfully")
                    setIsSnackBarShow(true)
                } else {
                    console.log("unable to issue refund");
                    setSnackBarMessage("Something went wrong")
                    setIsSnackBarShow(true)
                }
            })
        }
    }

    const deleteCourseCancellationRequest = () => {
        if (window.confirm("Are you sure you want to delete?")) {
            setDelLoading(true)
            deleteCourseCancellationRequest(id, (response) => deleteCallBack(response))
        }
    }

    const deleteCallBack = (response) => {

        setDelLoading(false)
        if (response.status == 200) {
            deleteRowInterface(index)
            setSnackBarMessage("Document Deleted Successfully")
            setIsSnackBarShow(true)
        }
        else {
            console.log("unable to delete");
            setSnackBarMessage("Something went wrong")
            setIsSnackBarShow(true)
        }
    }

    const closeSnack = () => {
        setIsSnackBarShow(false)
    }


    return (
        <>
            <tr>
                <td>{index + 1}</td>
                <td> {row.username}</td>
                <td>{row.userEmail}</td>
                <td>{row.userPhone}</td>
                <td>{row.refundAmount}</td>
                <td>{row.request_reason}</td>
                <td>{status}</td>
                <td>
                    <div className="row">
                        {status == COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.Pending ? (
                            <>

                                {updateStatus ? (
                                    <ClipLoader color={theme.primaryColor} loading={updateStatus} />
                                ) : (
                                    <button className="btn btn-danger" onClick={() => updateCourseCancellationRequestStatus(COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.Cancelled)}>Reject</button>
                                )}

                                {issuingRefund ? (
                                    <ClipLoader color={theme.primaryColor} loading={issuingRefund} />
                                ) : (
                                    <button className="btn btn-info" onClick={() => issueRefund()}>Issue Refund</button>
                                )}

                            </>
                        ) : (null)}
                        {status == COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.Cancelled ? (
                            <>

                                {updateStatus ? (
                                    <ClipLoader color={theme.primaryColor} loading={updateStatus} />
                                ) : (
                                    <button className="btn btn-warning" onClick={() => updateCourseCancellationRequestStatus(COURSE_CANCELLATION_REQUEST_STATUS_OPTIONS.Pending)}>Mark Pending</button>
                                )}

                                {issuingRefund ? (
                                    <ClipLoader color={theme.primaryColor} loading={issuingRefund} />
                                ) : (
                                    <button className="btn btn-info" onClick={() => issueRefund()}>Issue Refund</button>
                                )}

                            </>
                        ) : (null)}
                        {/* <div className="col-4">
                            <button className="btn btn-danger" onClick={() => delDocument(row.id)}>Delete</button>
                        </div> */}
                        <div className="col-4">
                            {delLoading ? (
                                <ClipLoader color={theme.primaryColor} loading={delLoading} />
                            ) : (
                                <button className="btn btn-danger" onClick={() => deleteCourseCancellationRequest()}>Delete</button>
                            )}
                        </div>
                    </div>
                </td>
            </tr>
            <Snackbar
                open={isSnackBarShow}
                onClose={(e) => closeSnack(e)}
                TransitionComponent="TransitionUp"
                message={SnackBarMessage}
            />
        </>
    )
}

export default CourseCancellationRequestRow
